import { render, staticRenderFns } from "./txt.vue?vue&type=template&id=8c9e3434&"
import script from "./txt.vue?vue&type=script&lang=js&"
export * from "./txt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c9e3434')) {
      api.createRecord('8c9e3434', component.options)
    } else {
      api.reload('8c9e3434', component.options)
    }
    module.hot.accept("./txt.vue?vue&type=template&id=8c9e3434&", function () {
      api.rerender('8c9e3434', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/plugins/export/txt.vue"
export default component.exports